export default __webpack_public_path__ + "126ef37cf469bc5c31c5aa26bfa7b46b.webp";